import FormSystemError from '../../../utils/form-error-constants';

class Newsletter {
  constructor() {
      let forbiddenAnotherClick = false;
      $('.newsletterForm button').on('click', (event) => {
          if (forbiddenAnotherClick) {
            return false;
          }
          forbiddenAnotherClick = true;
          let targetElement = $(event.target);
          let $form = targetElement.closest('form');
          let useCaptchaV2 = $form.data('use-captcha-v2');

          if (!useCaptchaV2) {
            return true;
          }

          initialCaptchaV2();

          event.preventDefault();
          $form.find('.recaptchaResponse').remove();
          let footerNewsletter = $(event.target).closest('.footerNewsletter');
          let itemNewsletter = $(event.target).closest('.item-newsletter');
          let widget;
          if (footerNewsletter.length) {
            widget = widgetId2;
          }

          if (itemNewsletter.length) {
            widget = widgetId3;
          }
          let response = grecaptcha.getResponse(widget);
          if (!response) {
              grecaptcha.execute(widget);
          }

          return;
      });
      $('.newsletterForm').submit((event) => {
      event.preventDefault();
      let $form = $(event.target).closest('form');
      let formSystemError = new FormSystemError($form);
      let useCaptchaV2 = $form.data('use-captcha-v2');
      let that = this;

      let footerNewsletter = $form.closest('.footerNewsletter');
      let itemNewsletter = $form.closest('.item-newsletter');
      let emailInput = $form.find('input[name=email]');

      this.hideNotifications(footerNewsletter);
      this.hideNotifications(itemNewsletter);
      this.hideNotifications(emailInput);

      let $required = $form.find('input:required').filter((index, element) => {
        return $(element).val().length === 0;
      });
      if ($required.length && !$form.hasClass('blog-newsletter')) {
        formSystemError.init();
        forbiddenAnotherClick = false;
        return;
      }
      if ($form.hasClass('blog-newsletter') && $required.length) {
        formSystemError.hideNoticeErrorNext($form.find('column'), $form);
        formSystemError.showNoticeErrorAfter($form.find('column'), $form,
        formSystemError.constants.field_required);
        forbiddenAnotherClick = false;
        return;
      }

      if (useCaptchaV2) {
        this.sendAjaxForm($form, formSystemError, footerNewsletter, itemNewsletter, emailInput);
        forbiddenAnotherClick = false;
      } else {
        let $recaptchaResponse = $form.find('.recaptchaResponse');
        grecaptcha.execute(window.recaptchaSitekeyV3, { action: 'newsletter' }).then(function (token) {
          $recaptchaResponse.val(token);
          that.sendAjaxForm($form, formSystemError, footerNewsletter, itemNewsletter, emailInput);
          forbiddenAnotherClick = false;
        });
      }
    });
  }

  done(form, parent, input, noticeAfter, data) {
    let $form = $(form);
    let $parent = $(parent);
    let $input = $(input);
    let $noticeAfter = $(noticeAfter);

    let formSystemError = new FormSystemError($form);

    formSystemError.hideNoticeErrorNext($input, $noticeAfter, formSystemError.constants.clang_newsletter_subscription_failed);

    if (data.statusCode === 2) {
      $parent.find('.notification.newsletter.subscribed').find('.customer_email').html($form.find('input[name=email]').val());
      $parent.find('.notification.newsletter.subscribed').removeClass('hidden');
      return;
    }

    if (data.statusCode === 0 || data.statusCode === 3) {
      formSystemError.showNoticeErrorAfter($input, $noticeAfter, formSystemError.constants.clang_newsletter_subscription_failed);
      return;
    }
    $parent.find('.notification.newsletter.success').removeClass('hidden');
  }

  hideNotifications($parent) {
    $parent.find('.notification.newsletter.failed').addClass('hidden');
    $parent.find('.notification.newsletter.success').addClass('hidden');
    $parent.find('.notification.newsletter.subscribed').addClass('hidden');
  }

  sendAjaxForm($form, formSystemError, footerNewsletter, itemNewsletter, emailInput) {
    let that = this;
    $.ajax({
      url: $form.attr('action'),
      type: $form.attr('method'),
      data: $form.serialize(),
    }).done(function(data) {
      formSystemError.removeErrors($form);
      that.done($form, footerNewsletter, footerNewsletter.find('form'),
          footerNewsletter.find('form'), data);
      that.done($form, itemNewsletter, itemNewsletter.find('form'),
          itemNewsletter.find('form'), data);
      that.done($form, $form, emailInput, emailInput.closest('.inputColumn'),
          data);
    }).fail(function(request) {
      let $inputEmail = $form.find("input[name='email']");
      let message = JSON.parse(request.responseText).message;

      formSystemError.hideNoticeErrorNext($inputEmail, $form);
      formSystemError.showNoticeErrorAfter($inputEmail, $form,
          message);
    }).always(function(request) {
      let responseText = request.responseText || '{}';
      let messageObject = JSON.parse(responseText);

      if (request.status === 400 && messageObject.captchaNotValid) {
        $form.data('use-captcha-v2', true);
      }
    });
  }
}

$(document).ready(function() {
  new Newsletter();
});